export default __webpack_public_path__ + "static/media/Button-Spin.de955e06.png";